import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    required,
} from "react-admin";

const CronJobsEdit = () => {
    return (
        <Edit
            resource="cron-jobs"
            mutationMode="optimistic"
        >
            <SimpleForm>
                <TextInput
                    source="name"
                    label="Cron Job Name"
                    fullWidth
                    validate={[required()]}
                />

                <TextInput
                    source="schedule"
                    label="Schedule (6-Field Cron)"
                    fullWidth
                    validate={[
                        required(),
                        (value) => {
                            if (!value) return undefined;
                            const fields = value.trim().split(/\s+/);
                            if (fields.length !== 6) {
                                return "Cron expression must contain exactly 6 fields";
                            }
                            const cronRegex = /^([0-9*/,\-]+\s){5}[0-9*/,\-]+$/;

                            if (!cronRegex.test(value)) {
                                return "Invalid characters in cron expression";
                            }
                            return undefined;
                        },
                    ]}
                    helperText="Format: second minute hour day month dayOfWeek (e.g., 0 0 12 * * *)"
                />

                <BooleanInput
                    source="isActive"
                    label="Is Active"
                    fullWidth
                />
            </SimpleForm>
        </Edit>
    );
};

export default CronJobsEdit;